import { render } from "./Formulario.vue?vue&type=template&id=003f65a4&scoped=true"
import script from "./Formulario.vue?vue&type=script&lang=js"
export * from "./Formulario.vue?vue&type=script&lang=js"

import "./Formulario.vue?vue&type=style&index=0&id=003f65a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-003f65a4"]])

export default __exports__